"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.innerArc = exports.outerArc = exports.polarToCartesian = void 0;
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
}
exports.polarToCartesian = polarToCartesian;
function outerArc(x, y, startAngle, endAngle, radius) {
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    var d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" ");
    return d;
}
exports.outerArc = outerArc;
function innerArc(x, y, startAngle, endAngle, innerRadius) {
    var start = polarToCartesian(x, y, innerRadius, endAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    var d = ["A", innerRadius, innerRadius, 0, largeArcFlag, 1, start.x, start.y].join(" ");
    return d;
}
exports.innerArc = innerArc;
//# sourceMappingURL=arc-functions.js.map